import { tt } from './i18n'

/**
 * What an order's status is called, in Slovak — §9.149.
 *
 * <p>Shared because two modules that do not depend on each other both draw it: `manager-orders` on
 * the archive, the till and the preorder list, and `manager-delivery` on the dispatch board. The
 * board rendered `order.status` raw for want of this — `new`, `preparing`, `quality_check` on a
 * screen the owner reads across a kitchen.
 *
 * <p>The **colours** deliberately do not live here. `manager-orders` keeps its badge palette, which
 * needs `@agos/ui`'s `BadgeColor`, and the dispatch board keeps legacy's own strip palette: the same
 * status is violet in one and near-black in the other, on purpose, because they are different
 * pictures. A shared colour map would have to pick one and break the other.
 */
export const ORDER_STATUS_LABELS: Record<string, string> = {
  pending: tt('Čaká na prijatie'),
  new: tt('Nová'),
  confirmed: tt('Potvrdená'),
  preparing: tt('Príprava'),
  quality_check: tt('Kontrola kvality'),
  ready: tt('Pripravená'),
  on_the_way: tt('Na ceste'),
  /* §9.707, FB-1011 - written by the driver's *Ísť na adresu* (§10A.341): the driver has set off for this stop. */
  at_address: tt('Ide na adresu'),
  delivered: tt('Doručená'),
  /* §9.523, FB-803 - a handover status this map did not have. `OrderStatusService`'s `REOPENABLE` names it
     beside `delivered` and `StockDeduction`'s javadoc treats the two the same way, so the server can hold it -
     and every screen drawing a status would have printed the key. Nought rows in either franchise today, which
     is why nobody had seen it. */
  picked_up: tt('Vyzdvihnutá'),
  cancelled: tt('Zrušená'),
}

/** The label, or the key itself when a franchise's backend sends one this map has not heard of. */
export function orderStatusLabel(status: string | undefined): string {
  if (!status) return ''
  return ORDER_STATUS_LABELS[status] ?? status
}
